import { NumberBox, NumberBoxLayoutStyle } from '@apply/components';
import { useStandardLoanStore } from '../../../../../../../../state/standardLoanStore';
import { isRequiredOnceNoteDated } from '../../../functions/isRequiredOnceNoteDated';

/** Part of a Custom term (TermInfo decides when it shows). Changing it recalculates the Maturity Date. */
export const InitialTermMonthsField = () => {
    const setup = useStandardLoanStore((state) => state.setup);
    const updateSetup = useStandardLoanStore((state) => state.updateSetup);

    return (
        <NumberBox
            id='setupInitialTermMonths'
            value={setup.initialTermMonths}
            onChange={(months) => updateSetup({ initialTermMonths: months ?? undefined })}
            label='Initial (mo.)'
            required={isRequiredOnceNoteDated(setup)}
            min={1}
            max={999}
            width='100%'
            height='36px'
            layoutStyle={NumberBoxLayoutStyle.Horizontal}
            labelWidth='100px'
        />
    );
};
